import React from "react";
import "./AnnotateBoxToolsPanel.css";
import AnnotateBoxStatsPanel from "./AnnotateBoxStatsPanel";
import AnnotateBoxPointsListPanel from "./AnnotateBoxPointsListPanel";

const AnnotateBoxToolsPanel = ({
  boxes,
  colorOptions,
  originalColonyBoxList,
  originalLabels,
  selectedId,
  isEditMode,
  selectedBox,
  readOnly = false,
  onAddBox,
  onSelectLabel,
  onSelectBox,
  onDeleteBox,
}) => (
  <aside className="AnnotateImageModal__RightPanel">
    <div className={`AnnotateImageModal__Tools ${readOnly ? "AnnotateImageModal__Tools--readonly" : ""}`}>
      <div className="AnnotateImageModal__Instructions">
        <h4 className="AnnotateImageModal__ToolsTitle">Instructions</h4>
        <ul className="AnnotateImageModal__MetaText">
          <li>Click &quot;Add&quot; to create a new bounding box</li>
          <li>Select a box to move or resize using handles</li>
          <li>Click the delete icon from the list to remove a box</li>
        </ul>
      </div>

      <AnnotateBoxStatsPanel
        boxes={boxes}
        colorOptions={colorOptions}
        originalColonyBoxList={originalColonyBoxList}
        originalLabels={originalLabels}
      />

      <AnnotateBoxPointsListPanel
        boxes={boxes}
        colorOptions={colorOptions}
        isEditMode={isEditMode}
        selectedBox={selectedBox}
        selectedId={selectedId}
        readOnly={readOnly}
        onAddBox={onAddBox}
        onSelectLabel={onSelectLabel}
        onSelectBox={onSelectBox}
        onDeleteBox={onDeleteBox}
      />
    </div>
  </aside>
);

export default AnnotateBoxToolsPanel;
